"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JEVMAPI = void 0;
const api_1 = require("../api");
const client_1 = require("../client");
const data_1 = require("../data");
const Service = 'june';
class JEVMAPI extends api_1.AbstractUtxoAPI {
    chain;
    rpcEndpoint;
    baseFeeCache = new data_1.CachedResponse(BigInt(60));
    constructor(client, chain) {
        super(client, `/ext/bc/${chain.id}/june`, Service);
        this.chain = chain;
        this.rpcEndpoint = `/ext/bc/${chain.id}/rpc`;
    }
    async getTx(txID, encoding) {
        const response = await this.call('getAtomicTx', [{ txID, encoding }]);
        return response.result;
    }
    async getTxStatus(txID) {
        const response = await this.call('getAtomicTxStatus', [{ txID }]);
        return response.result;
    }
    async eth_getAssetBalance(address, block, assetID) {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_getAssetBalance', [
            address,
            block,
            assetID
        ]);
        return BigInt.asUintN(256, response.result);
    }
    async eth_baseFee(forceUpdate = false) {
        return BigInt.asUintN(256, await this.baseFeeCache.rpcCall(this.client, this.rpcEndpoint, new client_1.JsonRpcRequest('eth_baseFee', []), forceUpdate));
    }
    async eth_maxPriorityFeePerGas() {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_maxPriorityFeePerGas');
        return BigInt.asUintN(256, response.result);
    }
    async eth_getChainConfig() {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_getChainConfig');
        return response.result;
    }
    async eth_getBalance(address, block) {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_getBalance', [address, block]);
        return BigInt.asUintN(256, response.result);
    }
    async eth_getTransactionCount(address, block) {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_getTransactionCount', [
            address,
            block
        ]);
        return BigInt.asUintN(256, response.result);
    }
    async eth_sendRawTransaction(transaction) {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_sendRawTransaction', [
            transaction
        ]);
        return response.result;
    }
    async eth_getTransactionReceipt(hash) {
        const response = await this.callServiceAt('', this.rpcEndpoint, 'eth_getTransactionReceipt', [
            hash
        ]);
        return response.result;
    }
}
exports.JEVMAPI = JEVMAPI;
